import { DropdownGroupReg } from './DropdownGroupReg';
import { RatingReg } from './RatingReg';
import { InputDataTypeEnum } from '../../enums/inputDataTypeEnum';

export class EventTypeInputReg {
    constructor(
        eventTypeInputRegId: string,
        eventTypeInputId: number,
        inputDataTypeId: InputDataTypeEnum,
        dropdownGroupReg: DropdownGroupReg | null,
        ratingReg: RatingReg | null,
        intValueReg: number | null,
        intValueRegStr: string | null,
        decimalValueReg: number | null,
        decimalValueRegStr: string | null,
        stringValueReg: string | null,
        datetimeValueReg: Date | null,
        checkboxValueReg: boolean | null,
        isEmpty: boolean
    ) {
        this.eventTypeInputRegId = eventTypeInputRegId;
        this.eventTypeInputId = eventTypeInputId;
        this.inputDataTypeId = inputDataTypeId;
        this.dropdownGroupReg = dropdownGroupReg;
        this.ratingReg = ratingReg;
        this.intValueReg = intValueReg;
        this.intValueRegStr = intValueRegStr;
        this.decimalValueReg = decimalValueReg;
        this.decimalValueRegStr = decimalValueRegStr;
        this.stringValueReg = stringValueReg;
        this.datetimeValueReg = datetimeValueReg;
        this.checkboxValueReg = checkboxValueReg;
        this.isEmpty = isEmpty;
        this.datetimeValueRegDisplay = null;
    }
    eventTypeInputRegId: string;
    eventTypeInputId: number;
    inputDataTypeId: InputDataTypeEnum;
    dropdownGroupReg: DropdownGroupReg | null;
    ratingReg: RatingReg | null;
    intValueReg: number | null;
    intValueRegStr: string | null;
    decimalValueReg: number | null;
    decimalValueRegStr: string | null;
    stringValueReg: string | null;
    datetimeValueReg: Date | null;
    checkboxValueReg: boolean | null;
    datetimeValueRegDisplay: Date | null; //view model;
    hasFocus = false; //View model
    hasBeenVisible = false; //View model
    isEmpty: boolean;
}
